import { render, staticRenderFns } from "./qualityApprovalList.vue?vue&type=template&id=1a7b0e8c&scoped=true"
import script from "./qualityApprovalList.vue?vue&type=script&lang=js"
export * from "./qualityApprovalList.vue?vue&type=script&lang=js"
import style0 from "./qualityApprovalList.vue?vue&type=style&index=0&id=1a7b0e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7b0e8c",
  null
  
)

export default component.exports